<template>
  <div class="input-panel input-panel--wide panel-pricing-data">
    <pricing-data-tabs></pricing-data-tabs>
  </div>
</template>

<script>
import swal from 'sweetalert'
import PricingDataTabs from './PricingDataTabs.vue'

export default {
  components: {
    'pricing-data-tabs': PricingDataTabs
  },
  data() {
    return {}
  },
  computed: {
    currentPricingData() {
      return this.$store.getters.currentPricingData
    },
    currentPricingRequest() {
      return this.$store.getters.currentPricingRequest
    },
    lastLoadedPricingRequest() {
      return this.$store.getters.lastLoadedPricingRequest
    },
    savedPricingRequests() {
      return this.$store.getters.savedPricingRequests
    },
    pricingRequestHasBeenEdited() {
      return !_.isEqual(this.currentPricingRequest, this.lastLoadedPricingRequest)
    },
    savedRegisteredPricingRequests() {
      if (this.savedPricingRequests.length) {
        let savedRegisteredPricingRequests = this.savedPricingRequests.filter(pricingRequest => pricingRequest.inputs.utility.plan.slug === 'free-registered')
        return savedRegisteredPricingRequests
      }

      return false
    }
  },
  methods: {
    savePricingRequest() {
      let self = this
      let utilityPlanSlug = this.currentPricingRequest.utility.plan.slug

      if (utilityPlanSlug === 'free-registered' && this.savedRegisteredPricingRequests.length) {

        if (this.pricingRequestHasBeenEdited) {
          let swalContent = document.createElement('div')
          swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will save one or more changes to your current set of saved inputs. Do you want to continue?</p>'

          swal({
            content: swalContent,
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                className: "",
                closeModal: true,
              },
              confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true
              }
            }
          }).then((result) => {
            if (result) {
              self.$store.dispatch('updatesavedPricingRequest') 
            }
          }).catch(function() {})

          return
        }
        
        self.$store.dispatch('updatesavedPricingRequest')
        return
      }

      // Has this config been previously saved?
      if (this.currentPricingRequest.savedPricingRequestId) {
        let swalContent = document.createElement('div')
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn mrgn-btm-0">Do you want to update your current request or save it as a new price request?</p> <p class="alerts message alerts--no-brdr error content-xxsm mrgn-btm-0">Selecting the <b>Update</b> button will replace all currently calculated prices, including historical pricing, with newly calculated values. This action is not reversible.</p>'

        swal({
          content: swalContent,
          closeOnEsc: false,
          className: 'swal--wide',
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Save as New",
              value: null,
              visible: true,
              className: "swal-button--cancel--blue",
              closeModal: true,
            },
            confirm: {
              text: "Update",
              value: true,
              visible: true,
              className: "",
              closeModal: true
            },
            close: {
              text: "Cancel",
              value: 'close',
              visible: true,
              className: "",
              closeModal: true
            }
          }
        }).then((result) => {
          if (result && result === 'close') {
            return
          } else if (result) {
            self.$store.dispatch('updatesavedPricingRequest')        
          } else {
            // console.log('close');
          }
        }).catch(function(action) {

          if (action === 'close') {
            return
          } 
        })

      } else {
        self.$store.dispatch('savecurrentPricingRequest') 
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    next()
  }
}
</script>
